export default ({request}) => ({
  cancelOrderListApi(data = {}) {
    return request({
      url: '/factory/cancelOrder/list',
      method: 'post',
      data,
    })
  },
  cancelOrderListByUserApi(data = {}) {
    return request({
      url: '/factory/cancelOrder/listByUser',
      method: 'post',
      data,
    })
  },
  cancelOrderDetailApi(data = {}) {
    return request({
      url: '/factory/cancelOrder/detail',
      method: 'post',
      data,
    })
  },
  cancelOrderAddApi(data = {}) {
    return request({
      url: '/factory/cancelOrder/add',
      method: 'post',
      data,
    })
  },
  cancelOrderDelApi(data = {}) {
    return request({
      url: '/factory/cancelOrder/del',
      method: 'post',
      data,
    })
  },
  cancelOrderEditApi(data = {}) {
    return request({
      url: '/factory/cancelOrder/edit',
      method: 'post',
      data,
    })
  },
  cancelOrderSubmitApi(data = {}) {
    return request({
      url: '/factory/cancelOrder/submit',
      method: 'post',
      data,
    })
  },
  cancelOrderReviewListApi(data = {}) {
    return request({
      url: '/factory/cancelOrderReview/list',
      method: 'post',
      data,
    })
  },
  cancelOrderReviewDetailApi(data = {}) {
    return request({
      url: '/factory/cancelOrderReview/detail',
      method: 'post',
      data,
    })
  },
  cancelOrderReviewSaveApi(data = {}) {
    return request({
      url: '/factory/cancelOrderReview/save',
      method: 'post',
      data,
    })
  },
  cancelOrderReviewDelApi(data = {}) {
    return request({
      url: '/factory/cancelOrderReview/del',
      method: 'post',
      data,
    })
  },
})
